module.exports = "<!--<input type=\"text\" placeholder=\"Search books ...\" [formControl]=\"searchTerm\" [matAutocomplete]=\"auto\">-->\r\n"